import { SelectItem, useTitleDirectorLazyQuery } from '@kistill/client/data-access'
import { Grid, IconButton, Link, TextFieldProps, Tooltip } from '@mui/material'
import React, { useRef, useState } from 'react'
import AddIcon from '@mui/icons-material/Add'
import InfoIcon from '@mui/icons-material/Info'
import { KistillFormAutocompleteTitle } from './KistillFormAutocompleteTitle'
import { Link as RouterLink } from 'react-router-dom'

interface TitleSelectorProps {
  name: string
  label: string
  inputProps?: TextFieldProps
  setOpenTitlePopup: (value: boolean) => void
  setSelectedTitle: React.Dispatch<React.SetStateAction<SelectItem | undefined>>
  selectedTitle: SelectItem | undefined
}

export function KistillTitleSelector({
  name,
  label,
  setOpenTitlePopup,
  setSelectedTitle,
  selectedTitle,
}: TitleSelectorProps) {
  const [selectedDirector, setSelectedDirector] = useState<string>()
  const currentGuidRef = useRef<string | undefined>(undefined)
  const [fetchDirector] = useTitleDirectorLazyQuery({ fetchPolicy: 'no-cache' })

  const handleTitleSelect: React.Dispatch<React.SetStateAction<SelectItem | undefined>> = (value) => {
    setSelectedTitle(value)
    const guid = typeof value === 'function' ? undefined : value?.id
    currentGuidRef.current = guid
    setSelectedDirector(undefined)
    if (guid) {
      void fetchDirector({ variables: { titleGuid: guid } }).then((res) => {
        if (currentGuidRef.current !== guid) return
        setSelectedDirector(res.data?.titleDirector ?? undefined)
      })
    }
  }

  return (
    <Grid item container alignItems='center'>
      <Grid item xs={11}>
        <KistillFormAutocompleteTitle
          name={`${name}`}
          label={label}
          multiple={false}
          onChange={(x) => x}
          selectedTitle={selectedTitle}
          setSelectedTitle={handleTitleSelect}
        />
      </Grid>
      <Grid item xs={1} justifyContent='center' pl={1}>
        <IconButton
          onClick={() => setOpenTitlePopup(true)}
          sx={{
            p: '4px',
            backgroundColor: (theme) => theme.palette.primary.main,
            color: (theme) => theme.palette.common.white,
          }}
        >
          <AddIcon />
        </IconButton>
      </Grid>
      {selectedTitle && (
        <Grid item container alignItems='center' fontSize='small'>
          <Link component={RouterLink} to={`/titill/${selectedTitle?.id}`}>
            {'Fara í titilskráningu'}
          </Link>
          <Tooltip
            title={`Leikstjóri: ${selectedDirector ? selectedDirector : 'Enginn fannst'}`}
            arrow
          >
            <IconButton
              size='small'
              sx={{ ml: 1, color: (theme) => theme.palette.primary.main }}
            >
              <InfoIcon fontSize='small' />
            </IconButton>
          </Tooltip>
        </Grid>
      )}
    </Grid>
  )
}
